// @ts-nocheck
// This file is generated by Umi automatically
// DO NOT CHANGE IT MANUALLY!
import RubyOutlined from '/opt/jenkins/workspace/maindash-front-new-2-prod/node_modules/@umijs/plugins/node_modules/@ant-design/icons/es/icons/RubyOutlined';
import DollarOutlined from '/opt/jenkins/workspace/maindash-front-new-2-prod/node_modules/@umijs/plugins/node_modules/@ant-design/icons/es/icons/DollarOutlined';
export default { RubyOutlined, DollarOutlined };
